const breadcrumbNames = {
  MANAGER: 'pages.manager.sidebar.manager',
  SETTING: 'pages.manager.sidebar.setting',
  PROJECT: 'pages.manager.sidebar.project',
  PLAN: 'pages.manager.sidebar.plan',
  REQUEST: 'pages.manager.sidebar.request',
  MY_ACCOUNT: 'pages.manager.sidebar.my_account',
  MESSAGE: 'pages.manager.sidebar.survey'
} as const

export default breadcrumbNames
